import { render, staticRenderFns } from "./ClientContactEdit.vue?vue&type=template&id=03c8af2c&"
import script from "./ClientContactEdit.vue?vue&type=script&lang=js&"
export * from "./ClientContactEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports